import { getActiveAccountAccessToken } from "./msal";

export async function get(url: string, signal?: AbortSignal) {
  const headers = await applyAuthorizationHeader({});

  const options: RequestInit = {
    headers,
    mode: "cors",
    ...(signal && { signal })
  };

  return fetch(url, options);
}

export async function post(url: string, body, signal?: AbortSignal) {
  const headers = await applyAuthorizationHeader({
    "Content-Type": "application/json"
  });

  const options: RequestInit = {
    body: JSON.stringify(body),
    mode: "cors",
    method: "post",
    headers,
    ...(signal && { signal }),
  };

  return fetch(url, options);
}

export async function put(url: string, body) {
  const headers = await applyAuthorizationHeader({
    "Content-Type": "application/json"
  });

  const options: RequestInit = {
    body: JSON.stringify(body),
    mode: "cors",
    method: "put",
    headers
  };

  return fetch(url, options);
}

export async function del(url: string, body?) {
  const headers = await applyAuthorizationHeader({
    "Content-Type": "application/json"
  });

  const options: RequestInit = {
    mode: "cors",
    method: "delete",
    headers
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  return fetch(url, options);
}

export async function postFormData(url: string, formData: FormData) {
  const headers = await applyAuthorizationHeader({});

  const options: RequestInit = {
    body: formData,
    mode: "cors",
    method: "post",
    headers
  };

  return fetch(url, options);
}

// this method will grab the active account's access token, if available, and
// apply it to the request object's headers
async function applyAuthorizationHeader(headers: HeadersInit) {
  const token = await getActiveAccountAccessToken();

  if (token?.accessToken) {
    headers["Authorization"] = `Bearer ${token.accessToken}`;
  }

  return headers;
}

// this method can be used by the SWR library as a generic fetcher
export async function fetcher<T>(url: string): Promise<T> {
  const headers = await applyAuthorizationHeader({});
  const response = await fetch(url, { headers, mode: "cors" });

  // throw an error here because SWR uses uncaught exceptions as the indicator
  // for error response
  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return response.json() as Promise<T>;
}
